import { Orgs as OrgsModule } from "../modules/Orgs/Orgs";

const Orgs = () => {
  return <OrgsModule />;
};

export default Orgs;
